import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Parametro, PolizaService } from '../poliza/poliza.service';
import * as printJS from "print-js";
import { environment } from 'src/environments/environment';
import { AuthUserRequestI } from '../Modelos/AuthUserRequest';

declare let mostrarLoader: Function;
declare let ocultarLoader: Function;
declare let mostrarToast: Function;

@Component({
  selector: 'app-impresion',
  templateUrl: './impresion.component.html',
  styleUrls: ['./impresion.component.css']
})
export class ImpresionComponent implements OnInit {
  sucursales: any[];
  ramos: any[];
  documentoTomador: any;
  nombreTomador: any;
  fechaEmision: any;
  pdfPolicy: any;
  pdfVoucher: any;
  poliza: any = {
    ramo: null,
    sucursal: null,
    numeroPoliza: ''
  };
  AuthUserRequestI:AuthUserRequestI;

  constructor(private polizaService: PolizaService) { }

  async ngOnInit() {
    this.ramos = await this.polizaService.consultarRamos();
    await this.cargarAgenciasFiltro();
  }

  async cargarAgenciasFiltro(){
    const cod_suc = sessionStorage.getItem('cod_suc'),
          cod_agt = sessionStorage.getItem('cod_agt'),
          cod_tagt = sessionStorage.getItem('cod_tagt');
    let parametrosAgencias: Parametro[]=[
        {llave: "cod_sucursal", valor: cod_suc ? cod_suc : '0'},
        {llave: "cod_agente", valor: cod_agt ? cod_agt : '0' },
        {llave: "cod_tipo_agente", valor: cod_tagt ? cod_tagt : '0'},
        {llave: "Cod_UsuarioSISE", valor:  sessionStorage.getItem("codusuariosise") ?  sessionStorage.getItem("codusuariosise") : '0'}
    ];

    let result=await (this.polizaService.consultarAgencias(true, parametrosAgencias));

    let agenciasResult = result.map(element => {return {codigo_agencia: element.codigoSucursal, nombre: element.nombreSucursal}});

    this.sucursales = [...agenciasResult];
  }

  async consultarPoliza(){
    mostrarLoader();
    if(!this.poliza.numeroPoliza || !this.poliza.ramo || !this.poliza.sucursal){
      mostrarToast("Todos los campos son requeridos.");
    }
    else{
      const poliza = await this.polizaService.validarPoliza(this.poliza.ramo, this.poliza.sucursal, this.poliza.numeroPoliza);
      this.poliza = { ...this.poliza, ...poliza };
      if(this.poliza.cod_doc_tomador == 0 && this.poliza.doc_tomador == 0 && !this.poliza.nombre_tomador){
        mostrarToast("No existe póli  za con los parámetros especificados.");
      }
      else{
        this.documentoTomador = this.poliza.tipo_doc_tomador.trim() + " - " + this.poliza.doc_tomador;
        this.nombreTomador = this.poliza.nombre_tomador;
        this.fechaEmision = this.poliza.fecha_emision.substring(0, 10).replaceAll("-", "/");
      }
    }
    ocultarLoader();
  }

  async imprimirPoliza(){
    mostrarLoader();
    (await this.polizaService.EncriptPassword()).subscribe(async (res) => {
      const clientIP = await this.polizaService.getClientIP();
      let ParamsToken = {
        IdAplicacion: environment.applicationId,
        Ip: clientIP,
        user: 'CUMPLIMIENTOAPIPRINTTEMPLATES',
        password: res
      };
      let jsonToken = JSON.stringify(ParamsToken);
      (await this.polizaService.obtenerToken(jsonToken)).subscribe(async (res) => {
        const clientIP = await this.polizaService.getClientIP();
        let ParamsPolicy = {
          id_Aplication: environment.applicationId,
          id_Ramo: this.poliza.ramo,
          id_Sucursal: this.poliza.sucursal,
          Nro_Poliza : this.poliza.numeroPoliza.toString(),
          nro_endoso: 0,
          Cod_Usuario: sessionStorage.getItem("codusuariosise"),
          ip: clientIP,
          mac: "Undefined"
        };
        let jsonPolicy = JSON.stringify(ParamsPolicy);
        (await this.polizaService.imprimirPoliza(jsonPolicy, res["token"])).subscribe(async (resp) => {

          printJS({
            printable: resp["arrBytes"],
            base64: true,
            type: "pdf"
          });
          ocultarLoader();
        });
      });
    });
  }


  async imprimirComprobante(){
    mostrarLoader();
    (await this.polizaService.EncriptPassword()).subscribe(async (res) => {
      const clientIP = await this.polizaService.getClientIP();
      let ParamsToken = {
        IdAplicacion: environment.applicationId,
        Ip: clientIP,
        user: 'CUMPLIMIENTOAPIPRINTTEMPLATES',
        password: res
      };
      let jsonToken = JSON.stringify(ParamsToken);
      (await this.polizaService.obtenerToken(jsonToken)).subscribe(async (res) => {
        const clientIP = await this.polizaService.getClientIP();
        let ParamsPolicy = {
          id_Aplication: environment.applicationId,
          id_Ramo: this.poliza.ramo,
          id_Sucursal: this.poliza.sucursal,
          Nro_Poliza : this.poliza.numeroPoliza.toString(),
          nro_endoso: 0,
          Cod_Usuario: sessionStorage.getItem("codusuariosise"),
          ip: clientIP,
          mac: "Undefined"
        };
        let jsonPolicy = JSON.stringify(ParamsPolicy);
        (await this.polizaService.imprimirComprobante(jsonPolicy, res["token"])).subscribe(async (resp) => {

          printJS({
            printable: resp["arrBytes"],
            base64: true,
            type: "pdf"
          });
          ocultarLoader();
        });
      });
    });
  }

}
